import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import { CHART_DOUGHNUT_CUTOUT_DEFAULT, ONE_HUNDRED } from "shared/constants";
import { useAppSelector } from "shared/hooks/redux/useAppSelector";
import theme from "shared/theme";
import { selectPrices } from "store/slices/prices";
import { selectTokens } from "store/slices/tokens";

import { IDoughnutProps } from "./interface";
import { setDoughnutData } from "../utils";

ChartJS.register(ArcElement, Tooltip, Legend);

export const ChartDoughnut: React.FC<IDoughnutProps> = ({
  cutout = CHART_DOUGHNUT_CUTOUT_DEFAULT,
  data = [ONE_HUNDRED],
  backgroundColor = [theme.colors.greyDoughnut],
  whiteListedTokens,
}: IDoughnutProps) => {
  const tokens = useAppSelector(selectTokens);
  const prices = useAppSelector(selectPrices);
  const doughnutData = whiteListedTokens ? setDoughnutData(whiteListedTokens, tokens, prices) : null;

  const dataOptions = {
    datasets: [
      {
        data: doughnutData ? doughnutData.data : data,
        backgroundColor: doughnutData ? doughnutData.colors : backgroundColor,
        borderWidth: 0,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    cutout,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => `$${context.formattedValue}`,
        },
      },
    },
  };

  return <Doughnut data={dataOptions} options={options} />;
};
